const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return { day, month, year };
};

export const getPrintTemplate = ({ data }) => {
  const { day, month, year } = splitDate(data.documentDate);

  return `
  <html>
    <head>
      <title>Giấy Đề Nghị Tạm Ứng</title>
      <style>
        @media print { @page { margin: 10mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 16px; color: #000; padding: 18px; }
        .header { display:flex; justify-content:space-between; }
        .right { text-align:center; line-height: 1.25; }
        .title { margin: 16px 0 4px; text-align:center; font-size: 32px; font-weight: 700; text-transform: uppercase; }
        .date { text-align:center; margin-bottom: 10px; }
        .row { margin-top: 8px; }
        .signatures { display:flex; justify-content:space-between; text-align:center; margin-top: 32px; }
        .sign-box { width: 24%; font-weight: 700; }
        .italic { font-style: italic; font-weight: 400; }
        .sign-name { margin-top: 4px; font-weight: 700; min-height: 20px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(data.unit)}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(data.department)}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số 03 - TT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">Giấy Đề Nghị Tạm Ứng</div>
      <div class="date">Ngày ${escapeHtml(day || "...")} tháng ${escapeHtml(month || "...")} năm ${escapeHtml(year || "....")}</div>

      <div class="row" style="text-align:right;">Số: ${escapeHtml(data.documentNumber)}</div>

      <div class="row"><b>Kính gửi:</b> ${escapeHtml(data.recipient)}</div>
      <div class="row">Tên tôi là: ${escapeHtml(data.requesterName)}</div>
      <div class="row">Địa chỉ: ${escapeHtml(data.requesterAddress)}</div>
      <div class="row">
        Đề nghị cho tạm ứng số tiền: ${escapeHtml(data.amountInNumber)}
        <span class="italic">(Viết bằng chữ)</span>: ${escapeHtml(data.amountInWords)}
      </div>
      <div class="row">Lý do tạm ứng: ${escapeHtml(data.reason)}</div>
      <div class="row">Thời hạn thanh toán: ${escapeHtml(data.paymentDeadline)}</div>

      <div class="signatures">
        <div class="sign-box">
          Giám đốc
          <div class="italic">(Ký, họ tên)</div>
          <div style="height:60px;"></div>
          <div class="sign-name">${escapeHtml(data.directorSignName || "")}</div>
        </div>
        <div class="sign-box">
          Kế toán trưởng
          <div class="italic">(Ký, họ tên)</div>
          <div style="height:60px;"></div>
          <div class="sign-name">${escapeHtml(data.chiefAccountantSignName || "")}</div>
        </div>
        <div class="sign-box">
          Phụ trách bộ phận
          <div class="italic">(Ký, họ tên)</div>
          <div style="height:60px;"></div>
          <div class="sign-name">${escapeHtml(data.departmentHeadSignName || "")}</div>
        </div>
        <div class="sign-box">
          Người đề nghị tạm ứng
          <div class="italic">(Ký, họ tên)</div>
          <div style="height:60px;"></div>
          <div class="sign-name">${escapeHtml(data.requesterSignName || data.requesterName || "")}</div>
        </div>
      </div>
      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
